import type { PelletsChartDataState } from "~/types/Charts";
import type { PelletsDisplay, PelletsState } from "~/types/Pellets";

export function buildPelletsDisplay(
  price: PelletsState,
  chartData: PelletsChartDataState,
): PelletsDisplay {
  return {
    loose: {
      price: price.loose,
      series: chartData.loose.data,
    },
    pallet: {
      price: price.pallet,
      series: chartData.pallet.data,
    },
  };
}
